import { useEffect, useState } from "react";
import { api, asArray } from "../../lib/api";

export const ClientWall = ({ dark = false }) => {
  const [clients, setClients] = useState([]);
  useEffect(() => {
    api.get("/clients").then((r) => setClients(asArray(r))).catch(() => setClients([]));
  }, []);

  if (!clients.length) {
    return (
      <div data-testid="client-wall-empty" className={`rounded-2xl border border-dashed px-6 py-12 text-center ${dark ? "border-white/20 text-paper/70" : "border-ink/25 text-ink/65"}`}>
        <p className="font-serif-i text-2xl">Our client roster is being curated.</p>
        <p className="mt-2 text-sm">Names and logos will appear here as engagements are announced.</p>
      </div>
    );
  }

  return (
    <div data-testid="client-wall" className={`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 border-l border-t ${dark ? "border-white/10" : "border-ink/15"}`}>
      {clients.map((c) => (
        <div key={c.id} data-testid={`client-${c.id}`} className={`group aspect-[3/2] border-r border-b p-6 flex flex-col items-center justify-center gap-3 transition-colors duration-500 ${dark ? "border-white/10 hover:bg-white/5" : "border-ink/15 hover:bg-paper"}`}>
          {c.logo ? (
            <img src={c.logo} alt={c.name} className="max-h-14 max-w-[75%] object-contain grayscale group-hover:grayscale-0 transition-[filter] duration-500" />
          ) : (
            <span className={`font-display font-bold text-lg text-center ${dark ? "text-paper" : "text-ink"}`}>{c.name}</span>
          )}
          <span className={`font-mono-x text-[11px] uppercase tracking-wider ${dark ? "text-paper/60" : "text-ink/60"}`}>{c.category}</span>
        </div>
      ))}
    </div>
  );
};
